/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessageInputArea.vue?vue&type=template&id=2d625655&scoped=true"
import script from "./ChatMessageInputArea.vue?vue&type=script&lang=js"
export * from "./ChatMessageInputArea.vue?vue&type=script&lang=js"
import style0 from "./ChatMessageInputArea.vue?vue&type=style&index=0&id=2d625655&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d625655",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d625655')) {
      api.createRecord('2d625655', component.options)
    } else {
      api.reload('2d625655', component.options)
    }
    module.hot.accept("./ChatMessageInputArea.vue?vue&type=template&id=2d625655&scoped=true", function () {
      api.rerender('2d625655', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/chat-message-list/ChatMessageInputArea.vue"
export default component.exports